import { supabase } from '@/lib/supabase';

export type BillingTextRow = {
  key: string;
  lang: string;
  text: string;
  updated_at: string;
  updated_by: string | null;
};

const SELECT_COLUMNS = 'key, lang, text, updated_at, updated_by';

export const billingTextsApi = {
  list: async (): Promise<BillingTextRow[]> => {
    const { data, error } = await supabase
      .from('billing_texts')
      .select(SELECT_COLUMNS)
      .order('key')
      .order('lang');
    if (error) throw error;
    return (data ?? []) as BillingTextRow[];
  },

  upsert: async (row: Pick<BillingTextRow, 'key' | 'lang' | 'text'>): Promise<BillingTextRow> => {
    const { data, error } = await supabase
      .from('billing_texts')
      .upsert(
        {
          key: row.key.trim(),
          lang: row.lang.trim() || 'he',
          text: row.text,
          updated_at: new Date().toISOString(),
        },
        { onConflict: 'key,lang' },
      )
      .select(SELECT_COLUMNS)
      .single();
    if (error) throw error;
    return data as BillingTextRow;
  },
};

export const BILLING_TEXT_PLACEHOLDERS = ['{signer}', '{org}', '{amount}', '{item}'] as const;
